module.exports = ".ngx-editor-grippie{height:9px;background-color:#f1f1f1;position:relative;text-align:center;cursor:s-resize;border:1px solid #ddd;border-top:transparent}.ngx-editor-grippie svg{position:absolute;top:1.5px;width:50%;right:25%}\n"


//////////////////
// WEBPACK FOOTER
// ./src/externals/ngx-editor/src/ngx-grippie/ngx-grippie.component.scss
// module id = ./src/externals/ngx-editor/src/ngx-grippie/ngx-grippie.component.scss
// module chunks = main